<template>
  <NavbarSMRmaster class="navbar" />

  <!-- Loading Modal with 'loading_modal' class -->
  <div v-if="isLoading" class="loading_modal">
    <div class="modal">
      <p>Loading data...</p>
      <div class="spinner"></div>
    </div>
  </div>

  <div class="pageheader">Program Administration</div>
  <div class="RL_note">List of administrative settings by Organization</div>

  <div class="gridContainer">
    <div class="gridHeaders">
      <div class="gridItem name">Organization</div>
      <div class="gridItem setting">Setting Name</div>
      <div class="gridItem value">Value</div>
      <div class="gridItem actions">Actions</div>
    </div>
    <div class="gridContent">
      <ul>
        <li v-for="setting in settings" :key="setting.id" class="gridRow">
          <div class="gridItem name">{{ setting.organization }}</div>
          <div class="gridItem setting">{{ setting.settingName }}</div>
          <div class="gridItem value">{{ setting.value }}</div>
          <div class="gridItem actions">
            <span class="material-icons edit" @click.stop="editSetting(setting.id)">edit</span>
            <span class="material-icons delete" @click.stop="deleteSetting(setting.id)">delete</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import NavbarSMRmaster from "../components/NavbarSMRmaster.vue";
import { db, ADMINsettingsColRef } from "../firebase";
import { query, getDocs, where, doc, collection, getDocsFromCache } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";

export default {
  name: 'ProgramAdmin',
  components: { NavbarSMRmaster },
  setup () {
    const settings = ref([]);
    const isLoading = ref(true);
    const organization = ref(null); // Current organization of the user
    const router = useRouter();
    const userRole = ref(null); // To store the user's role

    // Fetch data when the component is mounted
    onMounted(async () => {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        console.log("User is not authenticated");
        router.push("/login");  // Redirect to login if user is not authenticated
      } else {
        // Fetch organization for current user
        organization.value = await getUserOrganization(user.uid);
        userRole.value = await getUserRole(user.uid);

        if (organization.value) {
          await loadSettingsByOrganization(organization.value);
          isLoading.value = false;
        } else {
          console.error("No organization found for user.");
        }
      }
    });

    // Function to get the current user's organization
    const getUserOrganization = async (userId) => {
      try {
        // Query the 'Organizations' subcollection for the user
        const orgSubColRef = collection(db, "users", userId, "Organizations");
        const querySnapshot = await getDocs(orgSubColRef);

        // Check if we have results and return the first organization name
        if (!querySnapshot.empty) {
          // Assuming a user can have multiple organizations, you can choose the one that matches the input or return the first
          const orgData = querySnapshot.docs[0].data(); // Get the first organization data
          return orgData.OrgName; // Return the organization name
        } else {
          return null; // If no organizations are found, return null
        }
      } catch (error) {
        console.error("Error fetching user organization:", error);
        return null;
      }
    };

    // Function to get the current user's role
    const getUserRole = async (userId) => {
      try {
        // Query the 'Organizations' subcollection for the user
        const orgSubColRef = collection(db, "users", userId, "Organizations");
        const querySnapshot = await getDocs(orgSubColRef);

        // Check if we have results and return the role of the first organization
        if (!querySnapshot.empty) {
          const orgData = querySnapshot.docs[0].data(); // Get the first organization data
          return orgData.Role; // Return the role associated with the organization
        } else {
          return null; // If no organizations are found, return null
        }
      } catch (error) {
        console.error("Error fetching user role:", error);
        return null;
      }
    };

    // Function to load settings from ADMINsettings collection filtered by organization
    const loadSettingsByOrganization = async (org) => {
      try {
        const q = query(ADMINsettingsColRef, where("organization", "==", org));
        const querySnapshot = await getDocs(q);

        settings.value = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        console.log("Loaded settings:", settings.value);
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    // Edit a setting
    const editSetting = (id) => {
      router.push({ name: "EditSetting", params: { id } });
    };

    // Delete a setting
    const deleteSetting = async (id) => {
      if (!confirm("Are you sure you want to delete this setting?")) return;

      try {
        await deleteDoc(doc(adminSettingsColRef, id));
        settings.value = settings.value.filter((setting) => setting.id !== id);
        console.log(`Setting with ID ${id} deleted.`);
      } catch (error) {
        console.error("Error deleting setting:", error);
      }
    };

    return { 
      settings,
      isLoading,
      editSetting,
      deleteSetting
    };
  },
};
</script>

<style scoped>
/* Add your styles here for the new page */
</style>


<style scoped>
/* Styling for the form and report list */
body {
background: #fff2e6;
}
.pageheader {
position: fixed;  display: flex;
top: 70px;  left:0px;  height: 30px; width: 100%;
margin: 00px; padding: 10px;  
border-top: 5px; border-top: solid;  border-top-color: #02b8cc;
border-bottom: 1px;  border-bottom: solid;  border-bottom-color: #32e3f7;
background-color: #005ce6;  color: white;
font-size: x-large;
text-indent: 140px;
/*  justify-content: center; */
}
.button_addreport {
position: fixed; top: 138px;  left: 1150px; height: 30px;  width: 150px;  
box-sizing: border-box;
padding: 6px 15px;
border-radius: 12px;  background-color: #99cc00; box-shadow:0 4px 8px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
font-size: medium ; color: #000099; vertical-align: middle;
}
.RL_note {
position: fixed;
top:145px;  left: 100px;
}

/*--REPORT FORMATING -----------*/
/* Set font size for list items */
.gridContainer {
  position: fixed;
  top:180px;  margin-left: 100px;  
  max-width: 1400px;
  overflow-y: auto;
  scroll-behavior: smooth;
  font-size: 11px;
  height: 70vh; /* Adjust the height as needed */
}
.gridHeaders {
display: grid;
grid-template-columns: 175px 100px 100px 250px 75px 370px 30px 30px 70px;
gap: 5px;
padding: 5px;
background-color: #e9ecef;
margin-bottom: 4px; 
}
.gridContent ul {
  list-style-type: none; padding: 0; margin: 0;
}
.gridRow {
  display: grid; 
  grid-template-columns: 175px 100px 100px 250px 75px 375px 30px 30px 75px;
  gap: 5px;
  padding: 0px; margin-bottom: 4px; border-radius: 10px; background: #fff; font-size: 10pt;
  height: 30px;
}
.gridItem {
  padding: 5px;
}
/* Specific alignment for certain items */
.gridItem.name {justify-self: start;}
.gridItem.gamedate {justify-self: start;}
.gridItem.gamenumber { justify-self: center;}
.gridItem.leaguetypeseason {justify-self:left;}
.gridItem.genderage {justify-self: center;}
.gridItem.teams {justify-self: start;}
.gridItem.yellowcard {justify-self: center;}
.gridItem.redcard {justify-self: center;}
.gridItem.actions {justify-self: center;}

.gridContainer li:hover {
cursor: pointer;
background: #e6f5ff;
}

.material-icons {
cursor: pointer;
font-size: 18px;
color: #888;
}

.material-icons:hover {
color: #005ce6; /* Highlight edit on hover */
}

.material-icons.delete:hover {
color: red; /* Highlight delete on hover */
}
/* Styles for card counts */ 
.card-count { 
  display: flex; justify-content: center;  align-items: center;
  width: 20px; height: 20px; 
  border-radius: 35%; border: 1px solid black;
  font-size: 14px; color: white; font-weight: bold;
}
.card-count.yellow { background-color: yellow; color: black; }
.card-count.red { background-color: red; color: white; }

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it's above other content */
}

.modal {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  z-index: 1001; /* Ensure modal is above overlay */
}

.modal h3 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

select {
  width: 100%;
  padding: 10px;
  font-size: 16px;
}

.modal-buttons {
  display: flex;
  justify-content: space-between;
}

.modal-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.modal-buttons button:hover {
  background-color: #e0e0e0;
}

button {
  background-color: #005ce6;
  color: white;
  border-radius: 5px;
  padding: 10px 15px;
}

button:hover {
  background-color: #003f9a;
}

/* Modal Overlay */
.loading_modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Modal */
.modal {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 200px;
  text-align: center;
}

/* Spinner for loading animation */
.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

/* Spinner animation */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
